import { useEffect, useState } from "react";
import TestType from "../../../Types/TestType";

const TestBlock = ({
  question,
  answerList,
  chosen,
  chosenAnswerID,
}: TestType) => {
  const [answers, setAnswers] =
    useState<{ id: string; answer_text: string; chosen?: boolean }[]>(
      answerList
    );

  const test = {
    type: "multi",
  };

  useEffect(() => {
    const list = answerList.map((item) => ({ ...item, chosen: false }));

    setAnswers(list);
  }, [answerList]);

  useEffect(() => {
    if (test.type === "") {
      const chosenAnswer = answers.find((answer) => answer.chosen === true);

      if (chosenAnswer) {
        chosenAnswerID(chosenAnswer.id);
        chosen(true);
      } else {
        chosen(false);
      }
    } else if (test.type === "multi") {
      const chosenAnswer = answers.filter((answer) => answer.chosen === true);

      const answerList = chosenAnswer.map((item) => item.id);

      if (chosenAnswer.length > 0) {
        chosenAnswerID(answerList);
        chosen(true);
      } else {
        chosen(false);
      }
    }
  }, [answers]);

  function onAnswer(value: string) {
    if (test.type === "") {
      const list = answers.map((item) =>
        item.id === value
          ? { ...item, chosen: true }
          : { ...item, chosen: false }
      );

      setAnswers(list);
    } else {
      const list = answers.map((item) =>
        item.id === value ? { ...item, chosen: !item.chosen } : item
      );

      setAnswers(list);
    }
  }

  return (
    <div className="testBlock">
      <div
        className="testQuestionText"
        dangerouslySetInnerHTML={{ __html: question.question_text }}
      ></div>
      <h4>Выберете один правильный ответ или несколько правильных ответов</h4>
      <div className="testContent">
        <div className="answerList">
          {answers.map((answer, index) => {
            return (
              <div
                key={index}
                className={"answerBlock"}
                onClick={() => onAnswer(answer.id)}
              >
                <label
                  className={
                    test.type === "multi"
                      ? "customCheckbox"
                      : "customCheckbox circleCheckBox"
                  }
                >
                  <input
                    type="checkbox"
                    className="customCheckboxInput"
                    checked={answer.chosen}
                  />
                  <label
                    className={
                      test.type === "multi"
                        ? "customCheckboxSpan"
                        : "customCheckboxSpan circleCheckBox"
                    }
                  ></label>
                </label>
                <label
                  className={
                    answer.chosen ? "answerText selectedAnswer" : "answerText"
                  }
                  dangerouslySetInnerHTML={{ __html: answer.answer_text }}
                ></label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TestBlock;
